import BybVrSwitch from "@Components/game/common/dialog/byb-vr-switch";
import { GameModeCard } from "@Components/game/game-mode";
import { usePractiseContext } from "@Context/game/practise/practise-context";
import { AnalyticsEvents } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

const SlowtimeConfig = () => {
  const { i18n } = useI18n();
  const { sessionOptions, setSessionOptions } = usePractiseContext();
  const { track } = useAnalytics();

  const handleBulletTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSessionOptions({
      ...sessionOptions,
      bullet_time_decisions: event.target.checked,
    });
    track(AnalyticsEvents.practice_settings_adjusted, { bullet_time_decisions: event.target.checked });
  };

  return (
    <GameModeCard>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="text1xl500" color="dsNeutral.v300">
          {i18n("practice.slowtime")}
        </Typography>
        <BybVrSwitch checked={sessionOptions.bullet_time_decisions || false} onChange={handleBulletTimeChange} />
      </Stack>
    </GameModeCard>
  );
};

export default SlowtimeConfig;
